import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check--primary",
  "use": "check--primary-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check--primary\">\n    <path fill=\"#003595\" fill-rule=\"evenodd\" d=\"M9.593 16.458a1.365 1.365 0 0 1-.207-.17l-3.842-3.842a1.358 1.358 0 0 1 1.921-1.921l3.042 3.042 6.102-6.102a1.358 1.358 0 0 1 1.921 1.921l-7.044 7.045c-.522.52-1.36.53-1.893.027z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol